import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../_services/auth.service';

@Component({
    selector: 'error-page',
    templateUrl: './error-page.component.html',
    styleUrls: ['./error-page.component.css'],
    standalone: false
})
export class ErrorComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  image: any;
  errorType = 403;
  showError: any;
  messageType = [
    {
      type: 404,
      error: 'Page Not Found',
      def: `You seem to have clicked on a broken link or entered a URL that doesn't exist.`,
      img: 'assets/front/img/404.png',
    },
    {
      type: 403,
      error: 'Access Forbidden',
      def: `You don't have permission to access the requested page or resource.`,
      img: 'assets/front/img/403.png',
    },
    {
      type: 500,
      error: 'Something Went Wrong...',
      def: `We apologize and are fixing the problem. Please try again later.`,
      img: 'assets/front/img/500.png',
    },
    {
      type: 0,
      error: 'Under Maintenance',
      def: `We apologize and are fixing the problem. Please try again later.`,
      img: 'assets/front/img/000.png',
    },
  ];

  constructor(
    private auth: AuthService,
    public router: Router,
    public route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.errorType = parseInt(this.route.queryParams['value'].error);

    this.showError = this.messageType.filter(
      (item) => item.type === this.errorType
    )[0];
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((x) => x.unsubscribe());
  }
  navigateToHome() {
    if (this.auth.isCustomer()) {
      this.router.navigate(['/home']);
      return;
    }
    if (this.auth.isSupplier()) {
      this.router.navigate(['/']);
      return;
    }
    if (this.auth.isAdmin()) {
      this.router.navigate(['/admin']);
      return;
    }
  }
}
